import useGeneralStore from '../../../../store/general';
import { ConnectionsContext } from '../../../../App'
import customHeaders, { getSpace } from '../../../../common/headers';
import { ButtonActionDrop } from '../../../Buttons/ButtonActionDrop/ButtonActionDrop';
import { setAccountId, setName, setServiceData } from '../../../../pages/SettingsConnection/actions';
import useModal from '../../../../store/modal';
import { useShallow } from 'zustand/react/shallow';
import { useContext } from 'react';
import { ModalHistoryAccount } from '../../ModalHistoryAccount/ModalHistoryAccount';
import no_image from './img/no_image.svg'
import './SettingsRow.scss'
import { useState } from 'react';
import { TextPage } from '../../../TextPage/TextPage';

const SettingsRow = ({
    id,
    icon,
    name,
    isAdmin,
    key,
    btnFunc,
    setConnectedModal,
    status,
    access
}) => {
    const { dispatch } = useContext(ConnectionsContext);
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const [isModalHistory, setIsModalHistory] = useState(false)
    const {
        setIsModalActive,
        setFetchedServiceData,
        setIsCurrentArticle,
    } = useModal(
        useShallow((state) => ({
            setIsModalActive: state.setIsModalActive,
            setFetchedServiceData: state.setFetchedServiceData,
            setIsCurrentArticle: state.setIsCurrentArticle,
        }))
    );

    const onEditAccount = (account_id) => {
        if (account_id) {
            let url = `https://apps0.ecomru.ru:4242/api/v2/account/${account_id}`;

            fetch(url, { method: 'GET', headers })
                .then((res) => {
                    if (res.status === 204) {
                        console.log('no change data for this service');
                        return;
                    }
                    return res.json();
                })
                .then((json) => {
                    if (!json) return;
                    setFetchedServiceData(json);
                    setIsCurrentArticle(json?.article_id);
                    setConnectedModal(true);
                    dispatch(setAccountId(account_id));
                    dispatch(setName(json?.name));
                    dispatch(setServiceData(json));
                    setIsModalActive(true);
                })
                .catch((err) => {
                    console.error(err);
                })
        }
    };

    const btns = [
        { btn: 'История изменений', func: () => setIsModalHistory(true)},
        { btn: 'Редактировать', func: () =>  onEditAccount(id)},
        { btn: 'Удалить', func: () => btnFunc()}
    ];

    return (
        <>
            {isModalHistory &&
                <ModalHistoryAccount
                    account_id={id}
                    setIsModal={setIsModalHistory}
                />}

            <div className='settings-row' key={key}>
                <div className='settings-row__name'>
                    <img
                        style={{
                            width: '14px',
                            height: '14px'
                        }}
                        className='settings-row__icon'
                        onError={e => e.target.src = no_image}
                        src={status?.icon || no_image} />
                    <img
                        className='settings-row__icon'
                        onError={e => e.target.src = no_image}
                        src={icon || no_image} />
                    <span>{name + ' '}
                        {(access?.length > 0) &&
                            <>
                                <br />
                                <span style={{ display: 'inline', color: '#94A3B8', fontSize: '11px' }}>
                                    ({access.map((el, ind) => <TextPage
                                        key={el}
                                        text={el + ((access.length == ind + 1) ? '' : ', ')}
                                        style={{ display: 'inline', color: '#94A3B8', fontSize: '11px' }}
                                    />)})
                                </span>
                            </>
                        }
                    </span>
                </div>
                <div className='settings-row__tools'>
                    {
                        isAdmin ?
                            <div className='settings-row__btns'>
                                <ButtonActionDrop
                                    id={id}
                                    btns={btns}
                                />
                            </div>
                            :
                            null
                    }
                </div>
            </div>
        </>
    )
}

export { SettingsRow }
